__turbopack_context__.v({
  "authSuccess": "page-module__4El4dW__authSuccess",
  "authSuccessEmail": "page-module__4El4dW__authSuccessEmail",
  "authSuccessIcon": "page-module__4El4dW__authSuccessIcon",
  "authSuccessText": "page-module__4El4dW__authSuccessText",
  "backLink": "page-module__4El4dW__backLink",
  "button": "page-module__4El4dW__button",
  "buttonDanger": "page-module__4El4dW__buttonDanger",
  "buttonIcon": "page-module__4El4dW__buttonIcon",
  "buttonSecondary": "page-module__4El4dW__buttonSecondary",
  "buttonSmall": "page-module__4El4dW__buttonSmall",
  "buttonSuccess": "page-module__4El4dW__buttonSuccess",
  "container": "page-module__4El4dW__container",
  "emptyState": "page-module__4El4dW__emptyState",
  "emptyStateIcon": "page-module__4El4dW__emptyStateIcon",
  "error": "page-module__4El4dW__error",
  "form": "page-module__4El4dW__form",
  "generateButton": "page-module__4El4dW__generateButton",
  "generateButtonContent": "page-module__4El4dW__generateButtonContent",
  "header": "page-module__4El4dW__header",
  "inner": "page-module__4El4dW__inner",
  "input": "page-module__4El4dW__input",
  "inputGroup": "page-module__4El4dW__inputGroup",
  "inputRow": "page-module__4El4dW__inputRow",
  "label": "page-module__4El4dW__label",
  "loading": "page-module__4El4dW__loading",
  "loadingInline": "page-module__4El4dW__loadingInline",
  "optionsGrid": "page-module__4El4dW__optionsGrid",
  "result": "page-module__4El4dW__result",
  "resultActionList": "page-module__4El4dW__resultActionList",
  "resultContent": "page-module__4El4dW__resultContent",
  "resultHeader": "page-module__4El4dW__resultHeader",
  "resultSection": "page-module__4El4dW__resultSection",
  "resultSectionTitle": "page-module__4El4dW__resultSectionTitle",
  "resultSummary": "page-module__4El4dW__resultSummary",
  "resultTitle": "page-module__4El4dW__resultTitle",
  "resultUsage": "page-module__4El4dW__resultUsage",
  "searchInput": "page-module__4El4dW__searchInput",
  "section": "page-module__4El4dW__section",
  "sectionHeader": "page-module__4El4dW__sectionHeader",
  "sectionNumber": "page-module__4El4dW__sectionNumber",
  "sectionTitle": "page-module__4El4dW__sectionTitle",
  "select": "page-module__4El4dW__select",
  "selectedChipItem": "page-module__4El4dW__selectedChipItem",
  "selectedChipItemRemove": "page-module__4El4dW__selectedChipItemRemove",
  "selectedChipList": "page-module__4El4dW__selectedChipList",
  "selectedChipListEmpty": "page-module__4El4dW__selectedChipListEmpty",
  "spin": "page-module__4El4dW__spin",
  "spinner": "page-module__4El4dW__spinner",
  "spinnerSmall": "page-module__4El4dW__spinnerSmall",
  "subtitle": "page-module__4El4dW__subtitle",
  "success": "page-module__4El4dW__success",
  "title": "page-module__4El4dW__title",
  "variantAction": "page-module__4El4dW__variantAction",
  "variantActionAdd": "page-module__4El4dW__variantActionAdd",
  "variantActionRemove": "page-module__4El4dW__variantActionRemove",
  "variantContainer": "page-module__4El4dW__variantContainer",
  "variantInfo": "page-module__4El4dW__variantInfo",
  "variantItem": "page-module__4El4dW__variantItem",
  "variantItemSelected": "page-module__4El4dW__variantItemSelected",
  "variantList": "page-module__4El4dW__variantList",
  "variantListEmpty": "page-module__4El4dW__variantListEmpty",
  "variantListEmptyIcon": "page-module__4El4dW__variantListEmptyIcon",
  "variantPanel": "page-module__4El4dW__variantPanel",
  "variantPanelCount": "page-module__4El4dW__variantPanelCount",
  "variantPanelCountSelected": "page-module__4El4dW__variantPanelCountSelected",
  "variantPanelHeader": "page-module__4El4dW__variantPanelHeader",
  "variantPanelSelected": "page-module__4El4dW__variantPanelSelected",
  "variantSearch": "page-module__4El4dW__variantSearch",
  "variantTitle": "page-module__4El4dW__variantTitle",
  "variantUri": "page-module__4El4dW__variantUri",
});
